import styled from "@emotion/styled";

export const Button = styled.button`
  width: 100%;
  margin-block-start: 30px;
`;
